var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7726 16.2422V14.6554C13.7726 13.8137 13.4382 13.0065 12.843 12.4113C12.2479 11.8161 11.4407 11.4818 10.599 11.4818H4.25174C3.41004 11.4818 2.60282 11.8161 2.00765 12.4113C1.41249 13.0065 1.07813 13.8137 1.07812 14.6554V16.2422M10.599 5.13455C10.599 6.88729 9.17808 8.30816 7.42535 8.30816C5.67261 8.30816 4.25174 6.88729 4.25174 5.13455C4.25174 3.38181 5.67261 1.96094 7.42535 1.96094C9.17808 1.96094 10.599 3.38181 10.599 5.13455Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanIcon);
export default __webpack_public_path__ + "static/media/humanIcon.a3682c841c8db6f61c7779c865ecf08e.svg";
export { ForwardRef as ReactComponent };